import {AfterViewInit, Component, ElementRef, Renderer2, Input, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'questionnaire-grade',
  templateUrl: './questionnaire-grade.component.html',
  styleUrls: ['./questionnaire-grade.component.css']
})

export class QuestionnaireGradeComponent implements OnInit, AfterViewInit {
  @Input() questionnaireScoreArray: any; //打分等级
  @Output() outPutLevel = new EventEmitter<any>(); //回传打分等级

  afterQuestionnaireScoreArray: any; //过滤后的打分等级
  constructor(private el: ElementRef,
              private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.afterQuestionnaireScoreArray = this.questionnaireScoreArray.filter(d=>d.level!==0);
  }

  ngAfterViewInit(){

  }

  // 打分
  giveMark(index){
    for(let i = 0, len = this.afterQuestionnaireScoreArray.length; i<len; i+=1){
      if(i <= index){
        this.renderer.addClass(this.el.nativeElement.querySelector('.star-'+i), 'active');
      }else{
        this.renderer.removeClass(this.el.nativeElement.querySelector('.star-'+i), 'active');
      }
    }
    this.outPutLevel.emit(index);
  }

}



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-grade/questionnaire-grade.component.ts